import { render, staticRenderFns } from "./CBIACertificate.vue?vue&type=template&id=740194da&scoped=true"
import script from "./CBIACertificate.vue?vue&type=script&lang=js"
export * from "./CBIACertificate.vue?vue&type=script&lang=js"
import style0 from "./CBIACertificate.vue?vue&type=style&index=0&id=740194da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740194da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
